import asyncImport from './asyncImport';

const loaded = {
	debounce: null,
	anime: null,
};

const initImports = async () => {
	await asyncImport(loaded, ['debounce', 'anime']);
};

export default initImports;
export const debounce = () => loaded.debounce;
export const anime = () => loaded.anime;
